import React from 'react';
import { LISTING_HEAP_PAGE_AREA_IDS } from '../../../../constants';
import { ContactOrganizerButtonListings } from '../../../ContactOrganizerButtonListings/ContactOrganizerButtonListings';
import { FollowButton } from '../../../_shared/FollowButton/FollowButton';

import styles from './ActionBar.module.scss';

export type ActionBarProps = {
    captchaKey: string;
    isAuthenticated: boolean;
    gaCategory: string;
    showOnlyContactButton?: boolean;
    isCompact?: boolean;
};

export const ActionBar = ({
    captchaKey,
    isAuthenticated,
    gaCategory,
    showOnlyContactButton = false,
    isCompact = false,
}: ActionBarProps) => {
    return (
        <div className={styles.actionBar}>
            <ContactOrganizerButtonListings
                captchaKey={captchaKey}
                isVisible={false}
                isAuthenticated={isAuthenticated}
                gaCategory={gaCategory}
                domNodeId="event-page"
                className={`${styles.contactButton} ${
                    isCompact ? styles.compactButton : ''
                }`}
            />
            {!showOnlyContactButton && (
                <FollowButton
                    className={`${styles.button}`}
                    pageArea={LISTING_HEAP_PAGE_AREA_IDS.NEW_ORGANIZER_PANEL}
                />
            )}
        </div>
    );
};
